import biztDokService from '../services/BiztDokService';

export default {
    state: {
        docs: [],
        docTypes: {},
        dokDialogVisible: false,
    },

    getters: {
        getAllDocs: (state) => state.docs,

        // getSzabalyzat: (state) => ({
        //     /* id: state.docs[0].dokument_feltolt_id,
        //         nev: docTypes[0][1] */
        // }),
        //
        // getSzolgTabla: (state) => ({
        //     /* id: state.docs[0].dokument_feltolt_id,
        //         nev: docTypes[0][1] */
        // }),

        getDocTypes: (state) => state.docTypes,

        isDokDialogVisible: (state) => state.dokDialogVisible,
    },

    mutations: {
        /* eslint-disable no-param-reassign */
        setDocs: (state, docs) => {
            state.docs = docs;
        },
        setDocTypes: (state, docTypes) => {
            state.docTypes = docTypes;
        },

        closeDokDialog: (state) => {
            state.dokDialogVisible = false;
        },

        openDokDialog: (state) => {
            state.dokDialogVisible = true;
        },
        /* eslint-enable no-param-reassign */
    },

    actions: {
        getDocuments: (context, payload) => {
            biztDokService.getDocuments(
                payload.biztositok,
                payload.kock_kezd,
                payload.modozat,
                payload.dokument_feltolt_id,
                payload.dokmentum_code,
            ).then((response) => {
                context.commit('setDocs', response.data);
            });
        },

        getDocById: (context, id) => {
            biztDokService.getDocById(id);
        },

        getAllBdoktipus: (context) => {
            biztDokService.getAllBdoktipus().then((response) => {
                context.commit('setDocTypes', response.data);
            });
        },
    },
};
